import React, { useMemo } from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const Title = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.colors.grey[200]};
`

const Empty = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey[200]};
  font-style: italic;
`

const W = 320
const H = 80

const ComplianceTrendChart = ({ history }) => {
  const { path, fill, latest, min, max } = useMemo(() => {
    const rows = (history || []).filter(r => r.score !== null && r.score !== undefined)
    if (rows.length < 2) return { path: null }
    const xs = rows.length
    const points = rows.map((row, i) => {
      const x = (i / (xs - 1)) * (W - 8) + 4
      const score = Math.max(0, Math.min(100, row.score))
      const y = H - 4 - (score / 100) * (H - 8)
      return [x, y]
    })
    const path = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(' ')
    const fill = `${path} L ${points[points.length - 1][0].toFixed(1)} ${H} L ${points[0][0].toFixed(1)} ${H} Z`
    const scores = rows.map(r => Math.max(0, Math.min(100, r.score)))
    return {
      path,
      fill,
      latest: scores[scores.length - 1],
      min: Math.min(...scores),
      max: Math.max(...scores),
    }
  }, [history])

  if (!path) {
    return (
      <Wrap>
        <Empty>Your 90-day compliance trend will appear here over the next few weeks as history builds up.</Empty>
      </Wrap>
    )
  }

  return (
    <Wrap>
      <Title>Latest {Math.round(latest)}% · min {Math.round(min)}% · max {Math.round(max)}%</Title>
      <svg width="100%" height={H} viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" style={{ display: 'block' }}>
        <defs>
          <linearGradient id="cs-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0e7490" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#0e7490" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d={fill} fill="url(#cs-grad)" />
        <path d={path} fill="none" stroke="#0e7490" strokeWidth="2" />
      </svg>
    </Wrap>
  )
}

export default ComplianceTrendChart
